import { ErrorModalReducerState } from './errorModalTypes';

export const getErrorModalSelector = (state: any): ErrorModalReducerState =>
    state.getIn(['app', 'modal', 'errorModal']);
